import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import useAccountEnhanced from "../../../hooks/use-account-enhanced";
import { Card } from "src/components/card";
import { YellowMarkedRaw } from "../types/YellowMarkRaw";
import { useQuery } from "@tanstack/react-query";
import { hrisConfigQueryOptions } from "src/api/mvte/hris-rep-query-options";
import dayjs from "dayjs";

function YellowMarkedDisplay()
{
   const navigate = useNavigate();
   //const accountEnhanced = useAccountEnhanced();
   const [searchTerm, setSearchTerm] = useState("");
   const [columnFilters, setColumnFilters] = useState(
   {
       EmployeeUID: "",
       JobCode: "",
       DataSource: "",
       CreatedAtUtc: "",
       UpdatedAtUtc: "",
       EmployeeCode: "",
   });
   const [sortDir, setSortDir] = useState<true | false>(true)
   const [data, setData] = useState<YellowMarkedRaw[]>([]);

   const yellowMarkQuery = useQuery({ ...hrisConfigQueryOptions.yellowMarkedQueryOptions() });

   useEffect(() =>
   {
       if (yellowMarkQuery.data)
       {
           setData(yellowMarkQuery.data);
       }
   }, [yellowMarkQuery.data]);

   const filteredData = data.filter((yellowMark) =>
   {
       const employeeUID = `${yellowMark.EmployeeUID}`.toLowerCase();
       const jobCode = yellowMark.JobCode.toLowerCase();
       const dataSource = (yellowMark.DataSource ?? "").toLowerCase();
       const createdAtUtc = dayjs(yellowMark.CreatedAtUtc).format("MM/D/YYYY h:mm A").toLowerCase();
       const updatedAtUtc = dayjs(yellowMark.UpdatedAtUtc).format("MM/D/YYYY h:mm A").toLowerCase();
       const employeeCode = (yellowMark.EmployeeCode ?? "").toLowerCase();

       if (searchTerm.trim() !== "")
       {
           const term = searchTerm.toLowerCase();
           const matchesMain =
               employeeUID.includes(term) ||
               jobCode.includes(term) ||
               dataSource.includes(term) ||
               createdAtUtc.includes(term) ||
               updatedAtUtc.includes(term) ||
               employeeCode.includes(term);
           if (!matchesMain) return false;
       }

       if (columnFilters.EmployeeUID.trim() !== "" && !employeeUID.includes(columnFilters.EmployeeUID.toLowerCase())) return false;
       if (columnFilters.JobCode.trim() !== "" && !jobCode.includes(columnFilters.JobCode.toLowerCase())) return false;
       if (columnFilters.DataSource.trim() !== "" && !dataSource.includes(columnFilters.DataSource.toLowerCase())) return false;
       if (columnFilters.CreatedAtUtc.trim() !== "" && !createdAtUtc.includes(columnFilters.CreatedAtUtc.toLowerCase())) return false;
       if (columnFilters.UpdatedAtUtc.trim() !== "" && !updatedAtUtc.includes(columnFilters.UpdatedAtUtc.toLowerCase())) return false;
       if (columnFilters.EmployeeCode.trim() !== "" && !employeeCode.includes(columnFilters.EmployeeCode.toLowerCase())) return false;
       return true;
   });

   const sortData = sortDir === null ? filteredData : [...filteredData].sort((a,b) =>
   {
           const diff = dayjs(a.UpdatedAtUtc).valueOf() - dayjs(b.UpdatedAtUtc).valueOf();
           return sortDir ? diff : -diff;
   })

   function handleRowClick(yellow: YellowMarkedRaw)
   {
       navigate("/hr-config-management/yellow-employee-details", { state: { selectedRow: yellow } });
   }

   if (yellowMarkQuery.isLoading)
   {
       return (
           <Card>
               <div style={{ padding: "24px", textAlign: "center", color: "#555", fontSize: "15px" }}>
                   Loading Yellow Marked Employees...
               </div>
           </Card>
       );
   }

   return (
       <Card>
           <div style={{ padding: "24px" }}>
               <div style={toolbarStyle}>
                   <input type="text" placeholder="Search by value..." value={searchTerm} onChange= {(e) => setSearchTerm(e.target.value)} style={searchInputStyle}/>
               </div>
               <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto", border: "1px solid #000;"}}>
                   <thead>
                       <tr style={{ backgroundColor: "#f0f0f0" }}>
                           <th style={thStyle}>Employee UID</th>
                           <th style={thStyle}>Employee Code</th>
                           <th style={thStyle}>JobCode</th>
                           <th style={thStyle}>Data Source</th>
                           <th style={thStyle}>Created Date</th>
                           <th style={thStyle}>
                           Updates Date {"    "}
                           <button onClick={() => setSortDir(!sortDir)} title="Toggle ASC|DESC by Updated Date" style={sortButtonStyle}>
                               {sortDir ? "▲" : "▼"}
                           </button>
                           </th>
                       </tr>
                       <tr style={{ backgroundColor: "#f7f7f7" }}>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.EmployeeUID}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, EmployeeUID: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.EmployeeCode}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, EmployeeCode: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.JobCode}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, JobCode: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.DataSource}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, DataSource: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.CreatedAtUtc}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, CreatedAtUtc: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                           <th style={thStyle}>
                               <input
                                   type="text"
                                   placeholder="Filter..."
                                   value={columnFilters.UpdatedAtUtc}
                                   onChange={(e) => setColumnFilters((prev) => ({ ...prev, UpdatedAtUtc: e.target.value }))}
                                   style={columnSearchInputStyle}
                               />
                           </th>
                       </tr>
                   </thead>

                   <tbody>
                       {
                           sortData.map((yellow) => {
                           return (
                               <tr
                                   className="hover:underline hover:cursor-pointer"
                                   key={`${yellow.EmployeeUID}-${yellow.JobCode}`}
                                   onClick={() => handleRowClick(yellow)}
                                   style={{ cursor: "pointer" }}
                               >
                                   <td style={tdStyle}>{yellow.EmployeeUID}</td>
                                   <td style={tdStyle}>{yellow.EmployeeCode}</td>
                                   <td style={tdStyle}>{yellow.JobCode}</td>
                                   <td style={tdStyle}>{yellow.DataSource}</td>

                                   <td style={tdStyle}>
                                       <span title={yellow.CreatedAtUtc} style={{ cursor: "default" }}>
                                       {
                                           dayjs(yellow.CreatedAtUtc).format("MM/D/YYYY h:mm A")
                                       }
                                       </span>
                                   </td>

                                   <td style={tdStyle}>
                                       <span title={yellow.UpdatedAtUtc} style={{ cursor: "default" }}>
                                       {
                                           dayjs(yellow.UpdatedAtUtc).format("MM/D/YYYY h:mm A")
                                       }
                                       </span>
                                   </td>
                               </tr>
                           );
                           })
                       }
                   </tbody>
               </table>
           </div>
       </Card>
   );
}

const thStyle: React.CSSProperties =
{
   border: "1px solid #ccc",
   padding: "10px 12px",
   textAlign: "center",
   fontWeight: 600,
};
const tdStyle: React.CSSProperties =
{
   border: "1px solid #ccc",
   padding: "10px 12px",
   textAlign: "center",
   fontSize: "14px",
};
const columnSearchInputStyle: React.CSSProperties =
{
   width: "100%",
   padding: "4px 6px",
   fontSize: "12px",
   fontWeight: 400,
   border: "1px solid #ccc",
   borderRadius: "4px",
   outline: "none",
   boxSizing: "border-box",
   color: "#222",
};
const toolbarStyle: React.CSSProperties =
{
   display: "flex",
   justifyContent: "space-between",
   alignItems: "center",
   gap: "10px",
   marginBottom: "12px",
};
const searchInputStyle: React.CSSProperties =
{
   flex: 1,
   maxWidth: "320px",
   padding: "6px 10px",
   fontSize: "13px",
   border: "1px solid #ccc",
   borderRadius: "4px",
   outline: "none",
   color: "#222",
}
const sortButtonStyle: React.CSSProperties =
{
   padding: "0.6px",
   fontSize: "12px",
   cursor: "pointer",
   backgroundColor: "transparent",
   border: "1px solid #aaa",
   borderRadius: "4px",
   lineHeight: "1.6",
}
export { YellowMarkedDisplay };